import { Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Dashlet } from 'src/app/components/dashlet/component';
import { endpoints } from 'src/app/constants/endpoints';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Component({
    selector: 'new-pages-dashlet',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class NewPagesDashlet extends Dashlet {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  protected role = 'listing-admin';
  protected endpoint = endpoints.listing.newPages;
  public displayedColumns = ['title', 'created', 'actions'];
  pageEvent: PageEvent;

  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService // protected OrderApi: OrderApiService, // protected Dialog: MatDialog
  ) {
    super();
  }
}
